// extracted by mini-css-extract-plugin
export default {"modal":"AddNew_modal__9EyGZ","modal__shade":"AddNew_modal__shade__HpQdn","modal__form":"AddNew_modal__form__Fp-+d"};